var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#EC4899",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 39.5L35.5 29.25L39.875 24.875C41.75 23 42.375 20.5 41.75 19.25C40.5 18.625 38 19.25 36.125 21.125L31.75 25.5L21.5 23.25C20.875 23.125 20.375 23.375 20.125 23.875L19.75 24.5C19.5 25.125 19.625 25.75 20.125 26.125L26.75 30.5L24.25 34.25H20.5L19.25 35.5L23 38L25.5 41.75L26.75 40.5V36.75L30.5 34.25L34.875 40.875C35.25 41.375 35.875 41.5 36.5 41.25L37.125 41C37.625 40.625 37.875 40.125 37.75 39.5Z",
    stroke: "#EC4899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBest);
export default __webpack_public_path__ + "static/media/best.34e37f555c5467d5d3c1e211703b7599.svg";
export { ForwardRef as ReactComponent };